"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configCache;
function extractConfigFromDom() {
    var configSelector = '.o-keywordsearch__config';
    if (configCache) {
        return configCache;
    }
    var result = document.querySelector(configSelector).textContent;
    if (result) {
        try {
            // remove new lines
            result = result.replace(/\n/g, '');
            configCache = JSON.parse(result);
        }
        catch (error) {
            console.log('extractFromDom => Unreadable result', error, result);
        }
    }
    return configCache;
}
exports.extractConfigFromDom = extractConfigFromDom;
